<div class="row">

  <div class="col-sm-6">
    <div class="input-group input-group-sm">
      <nz-select [(ngModel)]="networkToAdd" class="form-control form-control-solid social-network-selector" [nzCustomTemplate]="defaultTemplate">
        <nz-option nzCustomContent nzValue="fa-lg fa-brands fa-instagram" nzLabel="instagram"><i class="fi fi-brands-instagram"></i> Instagram</nz-option>
        <nz-option nzCustomContent nzValue="fa-lg fa-brands fa-facebook" nzLabel="facebook"><i class="fi fi-brands-facebook"></i> Facebook</nz-option>
        <nz-option nzCustomContent nzValue="fa-lg fa-brands fa-twitter" nzLabel="twitter"><i class="fi fi-brands-twitter"></i> Twitter</nz-option>
        <nz-option nzCustomContent nzValue="fa-lg fa-brands fa-youtube" nzLabel="youtube"><i class="fa-brands fa-youtube"></i> Youtube</nz-option>
        <nz-option nzCustomContent nzValue="fa-lg fa-brands fa-twitch" nzLabel="twitch"><i class="fi fi-brands-twitch"></i> Twitch</nz-option>
        <nz-option nzCustomContent nzValue="fa-lg fa-brands fa-tiktok" nzLabel="tiktok"><i class="fa-brands fa-tiktok"></i> Tiktok</nz-option>
      </nz-select>
      <ng-template #defaultTemplate let-selected>
        <div class="ant-select-selection-item-content">
          <i [class]="selected.nzValue + ' me-2'"></i>
          {{ selected.nzLabel }}
        </div>
      </ng-template>
      <input [(ngModel)]="urlToAdd" type="text" aria-label="Paste profile link here" class="form-control flex-1">
      <button type="button" class="btn btn-outline-theme" (click)="add()">Add</button>
    </div>
  </div>

</div>

<div class="d-flex mt-4 flex-wrap">

<div class="single-social-network" *ngFor="let network of value; let i = index;">
    <i [class]="network.network"></i> <span>{{network.url}}</span> <i (click)="remove(i)" class="fi fi-br-cross-circle text-theme-primary text-hover-dark ms-auto"></i>
</div>

</div>
